import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { PunchPerforation } from "../models/PunchPerforation";

export const getPunchPerforations = async (
	productId: number,
): Promise<PunchPerforation[]> => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "ProductId", value: productId }];
	const resp = await apiService.callV2(
		"[FAB].[GetPunchPerforations]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as PunchPerforation[];
	}
	throw new Error(resp.message || "Error fetching punch perforations");
};

export const setPunchPerforations = async (
	productId: number,
	perforations: Array<
		Pick<
			PunchPerforation,
			| "PunchPerforationId"
			| "PerforationType"
			| "HoleSize"
			| "DetailNumber"
			| "PunchPartNumber"
			| "ButtonPartNumber"
		>
	>,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "ProductId", value: productId },
		{ name: "Perforations", value: JSON.stringify(perforations) },
	];
	return await apiService.callV2("[FAB].[SetPunchPerforations]", parameters);
};
